module.exports = __webpack_public_path__ + "static/treehouse-72c3c70d927effdaaa597c5d91d490e1.png";